import { createUseQuery } from "eddev/hooks";
import {
  UseCampaignPopupQuery,
  UseCaptchaQuery,
  UseCategoriesQuery,
  UseClubsQuery,
  UseContactDetailsQuery,
  UseCpdApplicationFormQuery,
  UseDocumentArchiveQuery,
  UseDocumentArchiveQueryVariables,
  UseDocumentIndexingQuery,
  UseDocumentTotalsQuery,
  UseDocumentTotalsQueryVariables,
  UseEvAvailabilityQuery,
  UseEvDataQuery,
  UseEvRegByPostcodeQuery,
  UseEvRegByStateQuery,
  UseEvVehiclePricingQuery,
  UseEvVehicleSpecsQuery,
  UseFocusAreasQuery,
  UseFormQuery,
  UseFormQueryVariables,
  UseGlossaryTermsQuery,
  UseIdpCarnetQuery,
  UseIdpDefaultsQuery,
  UseLatestNewsQuery,
  UseLatestNewsQueryVariables,
  UseMainSectionsNavQuery,
  UseMethodologyTooltipQuery,
  UseNewsArchiveQuery,
  UseNewsArchiveQueryVariables,
  UseNewsTotalsQuery,
  UseNewsTotalsQueryVariables,
  UsePageByPathQuery,
  UsePageByPathQueryVariables,
  UsePopularSearchesQuery,
  UseProjectsQuery,
  UseProjectsQueryVariables,
  UseProjectTotalsQuery,
  UsePublicationsQuery,
  UseRoadSafetyDataQuery,
  UseRoadSafetyHistoricDataQuery,
  UseSearchSupportQuery,
  UseSelectedDocumentQuery,
  UseSiteSearchQuery,
  UseSiteSearchQueryVariables,
  UseSocialLinksQuery,
  UseTransportDataQuery,
} from "../types.graphql";

/**
 * DO NOT EDIT
 * This file is automatically generated by eddev
 * Any changes will be overwritten
 */

export const useCampaignPopup = createUseQuery<UseCampaignPopupQuery, undefined>({ name: "UseCampaignPopup" });

export const useCaptcha = createUseQuery<UseCaptchaQuery, undefined>({ name: "UseCaptcha" });

export const useCategories = createUseQuery<UseCategoriesQuery, undefined>({ name: "UseCategories" });

export const useClubs = createUseQuery<UseClubsQuery, undefined>({ name: "UseClubs" });

export const useContactDetails = createUseQuery<UseContactDetailsQuery, undefined>({ name: "UseContactDetails" });

export const useCpdApplicationForm = createUseQuery<UseCpdApplicationFormQuery, undefined>({
  name: "UseCpdApplicationForm",
});

export const useDocumentArchive = createUseQuery<UseDocumentArchiveQuery, UseDocumentArchiveQueryVariables>({
  name: "UseDocumentArchive",
});

export const useDocumentIndexing = createUseQuery<UseDocumentIndexingQuery, undefined>({ name: "UseDocumentIndexing" });

export const useDocumentTotals = createUseQuery<UseDocumentTotalsQuery, UseDocumentTotalsQueryVariables>({
  name: "UseDocumentTotals",
});

export const useEvAvailability = createUseQuery<UseEvAvailabilityQuery, undefined>({ name: "UseEvAvailability" });

export const useEvData = createUseQuery<UseEvDataQuery, undefined>({ name: "UseEvData" });

export const useEvRegByPostcode = createUseQuery<UseEvRegByPostcodeQuery, undefined>({ name: "UseEvRegByPostcode" });

export const useEvRegByState = createUseQuery<UseEvRegByStateQuery, undefined>({ name: "UseEvRegByState" });

export const useEvVehiclePricing = createUseQuery<UseEvVehiclePricingQuery, undefined>({ name: "UseEvVehiclePricing" });

export const useEvVehicleSpecs = createUseQuery<UseEvVehicleSpecsQuery, undefined>({ name: "UseEvVehicleSpecs" });

export const useFocusAreas = createUseQuery<UseFocusAreasQuery, undefined>({ name: "UseFocusAreas" });

export const useForm = createUseQuery<UseFormQuery, UseFormQueryVariables>({ name: "UseForm" });

export const useGlossaryTerms = createUseQuery<UseGlossaryTermsQuery, undefined>({ name: "UseGlossaryTerms" });

export const useIdpCarnet = createUseQuery<UseIdpCarnetQuery, undefined>({ name: "UseIdpCarnet" });

export const useIdpDefaults = createUseQuery<UseIdpDefaultsQuery, undefined>({ name: "UseIdpDefaults" });

export const useLatestNews = createUseQuery<UseLatestNewsQuery, UseLatestNewsQueryVariables>({ name: "UseLatestNews" });

export const useMainSectionsNav = createUseQuery<UseMainSectionsNavQuery, undefined>({ name: "UseMainSectionsNav" });

export const useMethodologyTooltip = createUseQuery<UseMethodologyTooltipQuery, undefined>({
  name: "UseMethodologyTooltip",
});

export const useNewsArchive = createUseQuery<UseNewsArchiveQuery, UseNewsArchiveQueryVariables>({
  name: "UseNewsArchive",
});

export const useNewsTotals = createUseQuery<UseNewsTotalsQuery, UseNewsTotalsQueryVariables>({ name: "UseNewsTotals" });

export const usePageByPath = createUseQuery<UsePageByPathQuery, UsePageByPathQueryVariables>({ name: "UsePageByPath" });

export const usePopularSearches = createUseQuery<UsePopularSearchesQuery, undefined>({ name: "UsePopularSearches" });

export const useProjects = createUseQuery<UseProjectsQuery, UseProjectsQueryVariables>({ name: "UseProjects" });

export const useProjectTotals = createUseQuery<UseProjectTotalsQuery, undefined>({ name: "UseProjectTotals" });

export const usePublications = createUseQuery<UsePublicationsQuery, undefined>({ name: "UsePublications" });

export const useRoadSafetyData = createUseQuery<UseRoadSafetyDataQuery, undefined>({ name: "UseRoadSafetyData" });

export const useRoadSafetyHistoricData = createUseQuery<UseRoadSafetyHistoricDataQuery, undefined>({
  name: "UseRoadSafetyHistoricData",
});

export const useSearchSupport = createUseQuery<UseSearchSupportQuery, undefined>({ name: "UseSearchSupport" });

export const useSelectedDocument = createUseQuery<UseSelectedDocumentQuery, undefined>({ name: "UseSelectedDocument" });

export const useSiteSearch = createUseQuery<UseSiteSearchQuery, UseSiteSearchQueryVariables>({ name: "UseSiteSearch" });

export const useSocialLinks = createUseQuery<UseSocialLinksQuery, undefined>({ name: "UseSocialLinks" });

export const useTransportData = createUseQuery<UseTransportDataQuery, undefined>({ name: "UseTransportData" });
